const DIGITS = '۰۱۲۳۴۵۶۷۸۹'

export function toPersianNums(str: string | number): string {
  return String(str).replace(/[0-9]/g, (d) => DIGITS[+d])
}

export function toPersianSuffix(suf: string): string {
  return suf.replace('M', ' میلیون').replace('K', ' هزار').replace('%', '٪')
}
